import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  Container,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText
} from "reactstrap";
import { Redirect } from "react-router-dom";

import axios from "axios";

import { Button } from "components";

import nowLogo from "assets/img/nadu-logo-full.png";
// react component used to create sweet alerts
import SweetAlert from "react-bootstrap-sweetalert";

import bgImage1 from "assets/img/minibg/bg1.jpg";
import bgImage2 from "assets/img/minibg/bg2.jpg";
import bgImage3 from "assets/img/minibg/bg3.jpg";
import bgImage4 from "assets/img/minibg/bg4.jpg";
import bgImage5 from "assets/img/minibg/bg5.jpg";
import bgImage6 from "assets/img/minibg/bg6.jpg";
import bgImage7 from "assets/img/minibg/bg7.jpg";
import bgImage8 from "assets/img/minibg/bg8.jpg";
import bgImage9 from "assets/img/minibg/bg9.jpg";
import bgImage10 from "assets/img/minibg/bg10.jpg";
import bgImage11 from "assets/img/minibg/bg11.jpg";
import bgImage12 from "assets/img/minibg/bg12.jpg";

const API = "https://mi.nadunet.es/api/rest/";
const GET_USERNAME_URL = "nadulogin_resources/get_username.json";
const DO_LOGIN_URL = "user/login";
const GET_TOKEN_URL = "user/token";
const DO_LOGOUT_URL = "user/logout";
//replace :uid: with the User ID and :pass_reset_token: with the reset Token
const RESET_PASS_GET_TOKEN = "user/user_pass_reset";
//replace :uid: with the User ID and :pass_reset_token: with the reset Token
const RESET_PASS = "user/:uid:?pass-reset-token=:pass_reset_token:";
const bgs = [
  bgImage1,
  bgImage2,
  bgImage3,
  bgImage4,
  bgImage5,
  bgImage6,
  bgImage7,
  bgImage8,
  bgImage9,
  bgImage10,
  bgImage11,
  bgImage12
];
const recuperarPassStyle = {
  textAlign: "center",
  color: "red"
};

class ResetPass extends React.Component {
  constructor(props) {
    super(props);
    if (this.props.mainState.debug)
      console.log("########## PROPS RESET PASS ###########");
    if (this.props.mainState.debug) console.log(props);
    let fields = {
      confirm: "confirmPassField",
      pass: "passField"
    };
    let randomBgNumber = this.randomIntFromInterval(0, 11);
    let randomBg = bgs[randomBgNumber];

    this.state = {
      fields: fields,
      [fields.confirm]: "",
      [fields.pass]: "",
      username: "",
      loginError: false,
      isLogging: false,
      randomBg: randomBg,
      showPassword: false,
      pass_reset_token: "",
      alert: null,
      toRequest: false,
      toLogin: false
    };

    this.startLogin = this.startLogin.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.doLogin = this.doLogin.bind(this);
    this.getLoginButton = this.getLoginButton.bind(this);
    this.handleLoginError = this.handleLoginError.bind(this);
    this.cleanSession = this.cleanSession.bind(this);
    this.miniLogout = this.miniLogout.bind(this);
    this.showLoginError = this.showLoginError.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
    this.getToken = this.getToken.bind(this);
    this.successMessage = this.successMessage.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.checkPasswords = this.checkPasswords.bind(this);
    this.goToRequestPass = this.goToRequestPass.bind(this);
    this.goToLogin = this.goToLogin.bind(this);
  }
  successMessage() {
    this.setState({
      alert: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-120px" }}
          title="¡Guardada!"
          onConfirm={() => this.hideAlert()}
          onCancel={() => this.hideAlert()}
          confirmBtnBsStyle="info"
        >
          Ya está lista la nueva contraseña, ahora puedes iniciar sesión.
        </SweetAlert>
      )
    });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  getLoginButton() {
    let loginButton = null;

    if (this.state.isLogging) {
      loginButton = (
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>
      );
    } else {
      loginButton = "Cambiar contraseña";
    }

    return loginButton;
  }
  startLogin() {
    alert(
      "Usuario: " +
        this.state.dniField +
        "\nContraseña: " +
        this.state.passField
    );
    this.getUsername();
  }
  handleChange(field, event) {
    //////// console.log("Field name: " + field);
    //////// console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  setPassword(newToken) {
    //if (this.state.isLogging && !option) return;
    /* ////// console.log("################## GET USERNAME ################"); */

    /* ////// console.log(request); */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        //"X-CSRF-Token": newToken,
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };

    let request = {
      uid: this.props.mainState.resetPass.uid,
      timestamp: this.props.mainState.resetPass.timestamp,
      hashed_pass: this.props.mainState.resetPass.token
    };
    /* ////// console.log(request); */
    //this.setState({ isLoading: true });
    axios
      .post(API + RESET_PASS_GET_TOKEN, request, { headers: queryHeaders.headers, withCredentials: false })
      .then(result => {
        if (this.props.mainState.debug) console.log("################## RESPUESTA RESET SET PASSWORD ################");
        if (this.props.mainState.debug) console.log(result);
        if (result !== null && result.data != null) {
          this.setState({
            pass_reset_token: result.data.pass_reset_token
          });
          this.resetPassword(newToken);
        }
      })
      .catch(error => {
        // Error 😨
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          /* ////// console.log(error.response.data);
            ////// console.log(error.response.status);
            ////// console.log(error.response.headers); */

          this.handleLoginError(error.response.status);

          /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          /* ////// console.log(error.request); */
          //this.handleLoginError(666);
          /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
          // Something happened in setting up the request and triggered an Error
          /* ////// console.log('Error', error.message); */
          this.setState({
            error,
            isLogging: false
          });
        }
        /* ////// console.log(error.config); */
      });
  }
  resetPassword(newToken) {
    /* ////// console.log("################## GET USERNAME ################"); */

    let request = {
      pass: this.state.passField
    };
    /* ////// console.log(request); */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers:{
        //"X-CSRF-Token": newToken,
        "Content-Type": "application/json",
        "Accept": "application/json"
      }
    };
    axios
      .put(
        API +
          RESET_PASS.replace(
            ":uid:",
            this.props.mainState.resetPass.uid
          ).replace(":pass_reset_token:", this.state.pass_reset_token),
        request,
        {headers: queryHeaders.headers, withCredentials: false }
      )
      .then(result => {
        if (this.props.mainState.debug) console.log("################## RESPUESTA RESET ################");
        if (this.props.mainState.debug) console.log(result);
        if (result !== null && result.data != null && result.data.uid != null) {
          this.setState({
            isLogging: false,
            alert: (
              <SweetAlert
                success
                style={{ display: "block", marginTop: "-250px" }}
                title="¡Contraseña cambiada!"
                onConfirm={() => this.goToLogin()}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="info"
              >
                Ahora puedes iniciar sesión
              </SweetAlert>
            )
          });
        }
      })
      .catch(error => {
        // Error 😨
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          /* ////// console.log(error.response.data);
            ////// console.log(error.response.status);
            ////// console.log(error.response.headers); */

          this.handleLoginError(error.response.status);

          /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          /* ////// console.log(error.request); */
          //this.handleLoginError(666);
          /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
          // Something happened in setting up the request and triggered an Error
          /* ////// console.log('Error', error.message); */
          this.setState({
            error,
            isLogging: false
          });
        }
        /* ////// console.log(error.config); */
      });
  }
  checkPasswords(){
    let fields = this.state.fields;
    if (this.state[fields.pass] === this.state[fields.confirm]) {
      this.getToken();
    } else {
      this.setState({
        isLogging: false,
        alert: (
          <SweetAlert
            danger
            style={{ display: "block", marginTop: "-150px" }}
            title="Error"
            onConfirm={() => this.hideAlert()}
            onCancel={() => this.hideAlert()}
            confirmBtnBsStyle="info"
          >
            Las contraseñas no coinciden
          </SweetAlert>
        )
      });
    }
  }
  getToken() {
    /* ////// console.log("################## GET USERNAME ################"); */

    this.setState({
      isLogging: true
    });
    /* ////// console.log(request); */
    //this.setState({ isLoading: true });
    let queryHeaders = {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + GET_TOKEN_URL, {}, {headers: queryHeaders.headers, withCredentials: false })
      .then(result => {
        if (this.props.mainState.debug) console.log("################## RESPUESTA GET TOKEN ################");
        if (this.props.mainState.debug) console.log(result);
        this.setPassword(result.data.token);
      })
      .catch(error => {
        // Error 😨
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          /* ////// console.log(error.response.data);
            ////// console.log(error.response.status);
            ////// console.log(error.response.headers); */
          if (error.response.status == 401) {
            this.handleLoginError(999);
          } else {
            this.handleLoginError(error.response.status);
          }

          /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          /* ////// console.log(error.request); */
          //this.handleLoginError(666);
          /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
          // Something happened in setting up the request and triggered an Error
          /* ////// console.log('Error', error.message); */
          this.setState({
            error,
            isLogging: false
          });
        }
        /* ////// console.log(error.config); */
      });
  }
  showLoginError() {
    var options = {
      place: "tr",
      message: "Credenciales incorrectas",
      type: "danger",
      icon: "now-ui-icons objects_key-25",
      autoDismiss: 3
    };
    this.props.showNotification(options);
  }
  doLogin() {
    /* ////// console.log("################## DO LOGIN ################"); */
    let request = {
      username: this.state.username,
      password: this.state.passField
    };
    /* ////// console.log(request); */
    //this.setState({ isLoading: true });
    axios
      .post(API + DO_LOGIN_URL, request, { withCredentials: false })
      .then(result => {
        /* ////// console.log("################## RESPUESTA ################");
        ////// console.log(result); */
        this.setState({
          isLogging: false
        });
        this.props.godMode(result);
      })
      .catch(error => {
        // Error 😨
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          /* ////// console.log(error.response.data);
            ////// console.log(error.response.status);
            ////// console.log(error.response.headers); */

          this.handleLoginError(error.response.status);

          /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          /* ////// console.log(error.request); */
          this.handleLoginError(666);
          /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
          // Something happened in setting up the request and triggered an Error
          /* ////// console.log('Error', error.message); */
          this.setState({
            error,
            isLogging: false
          });
        }
        /* ////// console.log(error.config); */
      });
  }
  goToRequestPass(){
    this.setState({
      toRequest: true
    });
  }
  goToLogin(){
    this.props.goToLogin();
  }
  handleLoginError(error) {
    ////// console.log("#################### HANDLE ERROR ##################");
    ////// console.log(error);
    switch (error) {
      case 401:
        this.cleanSession();
        //this.getToken();
        break;
      case 406:
        this.setState({
          isLogging: false,
          alert: (
            <SweetAlert
              danger
              style={{ display: "block", marginTop: "-150px" }}
              title="¡Oh, no!"
              onConfirm={() => this.goToRequestPass()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            >
              El enlace ha caducado, solicita uno nuevo
            </SweetAlert>
          )
        });
        break;
      case 500:
        //this.getUsername(error);
        break;
      case 666:
        //this.getUsername(error);
        break;
      case 999:
        this.setState({
          isLogging: false,
          alert: (
            <SweetAlert
              danger
              style={{ display: "block", marginTop: "-150px" }}
              title="¡Oh, no!"
              onConfirm={() => this.goToRequestPass()}
              onCancel={() => this.hideAlert()}
              confirmBtnBsStyle="info"
            >
              El enlace ha caducado, solicita uno nuevo
            </SweetAlert>
          )
        });
        break;
      default:
        break;
    }
  }
  cleanSession() {
    let request = {};
    let newToken = "";

    //this.setState({ isLoading: true });
    axios
      .post(API + GET_TOKEN_URL, request, { withCredentials: true })
      .then(result => {
        ////// console.log("################## RESPUESTA GET TOKEN ################");
        ////// console.log(result);
        newToken = result.data.token;
        this.miniLogout(newToken);
      })
      .catch(error => {
        // Error 😨
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          ////// console.log(error.response.data);
          ////// console.log(error.response.status);
          ////// console.log(error.response.headers);

          this.handleLoginError(error.response.status);

          /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          ////// console.log(error.request);
          this.handleLoginError(666);
          /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
          // Something happened in setting up the request and triggered an Error
          ////// console.log('Error', error.message);
          this.setState({
            error,
            isLogging: false
          });
        }
        ////// console.log(error.config);
      });
  }
  miniLogout(newToken) {
    let request = {};
    let queryHeaders = {
      headers: {
        "X-CSRF-Token": newToken,
        "Content-Type": "application/json",
        Accept: "application/json"
      }
    };
    axios
      .post(API + DO_LOGOUT_URL, request, {
        headers: queryHeaders.headers,
        withCredentials: true
      })
      .then(result => {
        ////// console.log("################## RESPUESTA LOGOUT ################");
        ////// console.log(result);

        if (result.data[0]) {
          this.resetPassword();
        } else {
          this.cleanSession();
        }
      })
      .catch(error => {
        // Error 😨
        if (error.response) {
          /*
           * The request was made and the server responded with a
           * status code that falls out of the range of 2xx
           */
          ////// console.log(error.response.data);
          ////// console.log(error.response.status);
          ////// console.log(error.response.headers);

          this.handleLoginError(error.response.status);

          /* this.setState({
              error,
              isLogging: false
            }); */
        } else if (error.request) {
          /*
           * The request was made but no response was received, `error.request`
           * is an instance of XMLHttpRequest in the browser and an instance
           * of http.ClientRequest in Node.js
           */
          ////// console.log(error.request);
          this.handleLoginError(666);
          /* this.setState({
              error,
              isLogging: false
            }); */
        } else {
          // Something happened in setting up the request and triggered an Error
          ////// console.log('Error', error.message);
          this.setState({
            error,
            isLogging: false
          });
        }
        ////// console.log(error.config);
      });
  }
  randomIntFromInterval(min, max) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
  render() {
    if (this.state.toRequest === true) {
      return <Redirect to="/recuperar" />;
    }
    if (this.state.toLogin === true) {
      return <Redirect to="/entrar" />;
    }
    if (this.props.mainState.debug) console.log("########## PROPS RESET PASS ###########");
     if (this.props.mainState.debug) console.log(this.props);
    let fields = this.state.fields;
    let loginErrorMessage = (
      <div className="pull-left link footer-link">
        <h6>Credenciales incorrectas</h6>
      </div>
    );
    return (
      <div>
        <div className="full-page-content">
          {this.state.alert}
          <div className="login-page">
            <Container>
              <Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
                <Form>
                  <Card className="card-login card-plain">
                    <CardHeader>
                      <div className="logo-container">
                        <img src={nowLogo} alt="nadunet" />
                      </div>
                    </CardHeader>
                    <CardBody>
                      <InputGroup
                        className={
                          "no-border form-control-lg " +
                          (this.state.firstnameFocus ? "input-group-focus" : "")
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons objects_key-25" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type={!this.state.showPassword ? "password" : "text"}
                          placeholder="Contraseña"
                          onFocus={e => this.setState({ firstnameFocus: true })}
                          onBlur={e => this.setState({ firstnameFocus: false })}
                          value={this.state[fields.pass]}
                          onChange={e => this.handleChange(fields.pass, e)}
                        />
                      </InputGroup>
                      <InputGroup
                        className={
                          "no-border form-control-lg " +
                          (this.state.lastnameFocus ? "input-group-focus" : "")
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons objects_key-25" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type={!this.state.showPassword ? "password" : "text"}
                          placeholder="Repetir contraseña"
                          onFocus={e => this.setState({ lastnameFocus: true })}
                          onBlur={e => this.setState({ lastnameFocus: false })}
                          value={this.state[fields.confirm]}
                          onChange={e => this.handleChange(fields.confirm, e)}
                        />
                      </InputGroup>
                    </CardBody>
                    <CardFooter>
                      <Button
                        block
                        round
                        color={this.state.isLogging ? "default" : "primary"}
                        size="lg"
                        href=""
                        className="mb-3"
                        onClick={this.checkPasswords}
                      >
                        {this.getLoginButton()}
                      </Button>
                      {this.state.noMatch && loginErrorMessage}
                      {/* <div className="pull-right">
                        <h6>
                          <a href="#pablo" className="link footer-link">
                            Need Help?
                          </a>
                        </h6>
                      </div> */}
                      {!(this.state[fields.pass] == this.state[fields.confirm]) && <div style={recuperarPassStyle}>
                        Las contraseñas no coinciden
                      </div>}
                    </CardFooter>
                  </Card>
                </Form>
              </Col>
            </Container>
          </div>
        </div>
        <div
          className="full-page-background"
          style={{ backgroundImage: "url(" + this.state.randomBg + ")" }}
        />
      </div>
    );
  }
}

export default ResetPass;



// WEBPACK FOOTER //
// ./src/views/Pages/ResetPass.jsx